import {
  orangeShades,
  primaryColors,
  transparentColors,
  whiteShades
} from '@assets/styles/helpers/colors.styles'

export const snackbarStyles = {
  color: primaryColors.white,
  width: '100%',
  display: 'flex',
  boxSizing: 'border-box',
  padding: '0.5rem 0.625rem 0.5rem 0.625rem',
  borderRadius: '0.125rem',
  fontFamily: 'Helvetica Neue, sans-serif',
  fontWeight: 900,
  fontStretch: 'condensed',
  textTransform: 'uppercase',
  fontSize: '14px',
  alignItems: 'center',
  background: transparentColors.whiteShade3,
  backdropFilter: 'blur(10px)',
  '&.MuiAlert-colorInfo': {
    borderLeft: `0.25rem solid ${whiteShades.shade1}`,
    '.las': {
      lineHeight: '1.5rem'
    }
  },
  '&.MuiAlert-colorError': {
    borderLeft: `0.25rem solid ${primaryColors.orange}`,
    '.las': {
      lineHeight: '1.5rem'
    }
  },
  '&.MuiAlert-colorSuccess': {
    borderLeft: `0.25rem solid ${primaryColors.white}`,
    '.las': {
      lineHeight: '1.5rem'
    }
  },
  '&.MuiAlert-colorWarning': {
    borderLeft: `0.25rem solid ${orangeShades.shade1}`,
    '.las': {
      lineHeight: '1.5rem'
    }
  },
  '.MuiAlert-message': {
    padding: 0,
    textAlign: 'center',
    height: 'fit-content',
    marginRight: '0.5rem'
  },
  '.MuiAlert-icon': {
    padding: 0,
    marginRight: '0.5rem',
    alignSelf: 'flex-start'
  },
  '.MuiAlert-action': {
    alignSelf: 'flex-start',
    padding: '0 0.5rem 0 0',
    '.MuiIconButton-root': {
      padding: 0,
      fontSize: '1.5rem',
      color: whiteShades.shade1,
      '&:hover': {
        color: whiteShades.shade2
      },
      '&:active': {
        color: whiteShades.shade3
      },
      '&:focus': {
        outline: 'none'
      },
      '&:focus-visible': {
        outline: 'none'
      },
      '.MuiTouchRipple-root': {
        display: 'none'
      }
    }
  }
}
